module.exports = __webpack_public_path__ + "img/Syg_icon_sdfsdfsdf.125f058b.png";